// extracted by mini-css-extract-plugin
module.exports = {"track":"style_track__P0BuT"};